import { useCallback } from 'react'

import { useSegment } from '../../../hooks'
import { useBalanceConfig } from '../contexts/balanceSideContext'
import type { BalanceTrackingAction } from '../types/balanceTrackingAction'

export const useTrackBalanceEvent = () => {
  const { trackingObject } = useBalanceConfig()
  const { track } = useSegment()

  return useCallback(
    (action: BalanceTrackingAction, payload?: Record<string, unknown>) => {
      track(`xxx - ${trackingObject} ${action} (Client)`, payload)
    },
    [track, trackingObject],
  )
}
